module.exports = __webpack_public_path__ + "static/media/overlay_loader.9d5b74d0.gif";